import i18n from "i18next";
import translationDECH from "./locales/de-CH/translation.json";
import translationFRCH from "./locales/fr-CH/translation.json";
import translationITCH from "./locales/it-CH/translation.json";
import translationDEDE from "./locales/de-DE/translation.json";
import translationEN from "./locales/en/translation.json";
import { initReactI18next } from "react-i18next/initReactI18next";

const resources = {
  de: {
    translation: translationDEDE,
  },
  "de-CH": {
    translation: translationDECH,
  },
  "fr-CH": {
    translation: translationFRCH,
  },
  "it-CH": {
    translation: translationITCH,
  },
  en: {
    translation: translationEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "de-CH", // default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
